import {FC} from 'react';
import {Switcher} from '@tickchak/react-share/app';
import KebabDots from '../../../../../../assets/icons/KebabDots';
import * as css from '../AddLecturerPopup.css';

interface Props {
    isActive: boolean;
    onToggle: (v: boolean) => void;
    t: (k: string) => string;
}

const PopupHeaderEnd: FC<Props> = ({isActive, onToggle, t}) => (
    <css.headerEnd>
        <Switcher
            checked={isActive}
            onChange={e => onToggle(e.target.checked)}
            label={{on: t('toggleActive'), off: t('toggleInactive'), show: true}}
            ariaLabel={t('toggleActive')}
        />
        <css.kebab type="button" aria-label="more"><KebabDots /></css.kebab>
    </css.headerEnd>
);

export default PopupHeaderEnd;
